import {ValueObject} from '@s-ui/domain'

export class UnsubscribeUserFavoriteRequestFactory extends ValueObject {
  /**
   * @param {String} userId
   * @param {String} adId
   **/

  static validate({userId, adId, token, unsubscribeFavoriteUserError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''
    if (!checkValidData(userId)) throw unsubscribeFavoriteUserError('userId is required')
    if (!checkValidData(adId)) throw unsubscribeFavoriteUserError('adId is required')
    if (!checkValidData(token)) throw unsubscribeFavoriteUserError('token is required')
  }
}
